import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function ChangePassword() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [old, setOld] = useState("");
  const [np, setNp] = useState("");
  const [np2, setNp2] = useState("");
  const [loading, setLoading] = useState(false);

  if (!user) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (np !== np2) return toast.error("Le due nuove password non coincidono");
    if (np.length < 8) return toast.error("Almeno 8 caratteri");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { old_password: old, new_password: np });
      toast.success("Password aggiornata");
      setOld(""); setNp(""); setNp2("");
      nav(-1);
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md">
      <div className="eyebrow">Account</div>
      <h1 className="mt-1 text-3xl">Cambia password</h1>
      <p className="mt-2 text-sm text-ink-500">Utente: {user.email}</p>
      <form onSubmit={submit} className="mt-6 card-elevated p-6 space-y-4" data-testid="change-password-form">
        <div>
          <Label htmlFor="old">Password attuale</Label>
          <Input id="old" type="password" value={old} onChange={(e) => setOld(e.target.value)}
                 data-testid="cp-old" required autoFocus />
        </div>
        <div>
          <Label htmlFor="new">Nuova password</Label>
          <Input id="new" type="password" value={np} onChange={(e) => setNp(e.target.value)}
                 data-testid="cp-new" required />
          <p className="mt-1 text-xs text-ink-500">Almeno 8 caratteri, una lettera e un numero. Non uguale all'attuale.</p>
        </div>
        <div>
          <Label htmlFor="new2">Conferma nuova password</Label>
          <Input id="new2" type="password" value={np2} onChange={(e) => setNp2(e.target.value)}
                 data-testid="cp-new2" required />
        </div>
        <div className="flex gap-2">
          <Button type="submit" className="rounded-full" data-testid="cp-submit" disabled={loading}>
            {loading ? "Aggiorno…" : "Aggiorna password"}
          </Button>
          <Button type="button" variant="outline" className="rounded-full" onClick={() => nav(-1)}>Annulla</Button>
        </div>
      </form>
    </div>
  );
}
